import { ComponentTierName, StationTier } from './enums';

export interface Permission {
  component: ComponentTierName;
  roles: StationTier[];
}

//If the requested permission exists then it will appear
const permissionsConfig: Permission[] = [
  {
    component: ComponentTierName.CompressorView,
    roles: [StationTier.Monitor, StationTier.Asset, StationTier.SimpleControl],
  },
  {
    component: ComponentTierName.StationControlCenterView,
    roles: [StationTier.Monitor, StationTier.Asset],
  },
  {
    component: ComponentTierName.AddNewController,
    roles: [StationTier.Monitor, StationTier.Asset, StationTier.SimpleControl],
  },
  {
    component: ComponentTierName.ControlCenterKPIs,
    roles: [StationTier.Asset],
  },
  {
    component: ComponentTierName.TrendsView,
    roles: [StationTier.Monitor, StationTier.Asset],
  },
  {
    component: ComponentTierName.MapView,
    roles: [StationTier.Monitor, StationTier.Asset, StationTier.SimpleControl],
  },
  {
    component: ComponentTierName.EnergySavingsWidget,
    roles: [StationTier.Monitor, StationTier.Asset],
  },
  {
    component: ComponentTierName.InvestigationDashboard,
    roles: [StationTier.Monitor, StationTier.Asset, StationTier.SimpleControl],
  },
  {
    component: ComponentTierName.Insights,
    roles: [StationTier.SimpleControl, StationTier.Monitor, StationTier.Asset],
  },
  {
    component: ComponentTierName.Leakage,
    roles: [StationTier.Monitor, StationTier.Asset, StationTier.SimpleControl],
  },
  {
    component: ComponentTierName.SystemHealth,
    roles: [StationTier.Monitor, StationTier.Asset, StationTier.SimpleControl],
  },
  { component: ComponentTierName.SystemHealthAsset, roles: [StationTier.Asset] },
  {
    component: ComponentTierName.PaymentPlan,
    roles: [StationTier.Asset],
  },
  {
    component: ComponentTierName.ProactiveEngine,
    roles: [StationTier.Asset, StationTier.Monitor, StationTier.SimpleControl],
  },
  {
    component: ComponentTierName.CompressorModalInfoIcons,
    roles: [StationTier.Asset, StationTier.Monitor, StationTier.SimpleControl],
  },
  {
    component: ComponentTierName.CompressorModalLockButton,
    roles: [StationTier.Asset, StationTier.Monitor],
  },
  { component: ComponentTierName.TrendsViewMockAsset, roles: [StationTier.Asset] },
  { component: ComponentTierName.StationRiskMock, roles: [StationTier.Asset] },
];

export default permissionsConfig;
